import { getTextValue } from '@/lib/helpers/LocalizedText'
import { getOpeningHoursForDate } from '@/lib/helpers/OpeningHours.js'
import { preconfiguredPageRoutes } from '@/config'
import moment from 'moment'

import Vue from 'vue'

import { PageRequests } from '@/services/pages.requests'

const pageService = new PageRequests()

const state = {
  dashboardItems: [],
  page: null,
  openingHours: [],
  slots: null,
  storedSlots: {},
  upcomingEvents: [],
  upcomingEventsFilters: {
    startDate: null,
    endDate: null,
    activityCategoryIds: [],
  },
}

const getters = {
  getDashboardName: (state) => ({ routeName }) => {
    try {
      const dashboardItem = state.dashboardItems.find(
        (dashboardItem) => {
          if (!!dashboardItem.preconfiguredPage) {
            return routeName === preconfiguredPageRoutes[dashboardItem.preconfiguredPage.pageName]
          } else {
            return false
          }
        })
      if (dashboardItem) {
        return getTextValue(dashboardItem.preconfiguredPage.title)
      } else {
        return
      }
    } catch(e) { return null }
  },
  pageName: (state) => {
    return !!state.page ? getTextValue(state.page.pageSpecific.title) : null
  },
  coverImageUrl: (state) => {
    return !!state.page ? state.page.coverImageUrl : null
  },
}

const actions = {
  getDashboardItems ({ commit }) {
    return new Promise((resolve, reject) => {
      pageService.getDashboardItems().then((dashboardItems) => {
        commit('setDashboardItems', dashboardItems)
        resolve(state.dashboardItems)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  get ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      pageService.get(id).then((page) => {
        commit('setPage', page)
        resolve(state.page)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getOpeningHours ({ commit }, { startDate, endDate, activityCategoryIds }) {
    return new Promise((resolve, reject) => {
      pageService.getOpeningHours(startDate, endDate, activityCategoryIds).then((upcomingEvents) => {
        upcomingEvents.sort((a, b) => {
          if (a.start > b.start) {
            return 1
          } else if (a.start < b.start) {
            return -1
          } else {
            return 0
          }
        })
        commit('setUpcomingEvents', { upcomingEvents, startDate, endDate,  activityCategoryIds})
        resolve(upcomingEvents)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getPageOpeningHours ({ state, dispatch }, { pageId, start, end, date, storeSlots }) {
    return new Promise((resolve, reject) => {
      pageService.getPageOpeningHours(pageId, { start, end, date }).then((openingHours) => {
        state.openingHours = openingHours
        if (storeSlots) {
          dispatch('storeSlots', { pageId, start, end, openingHours }).then(() => {
            resolve(openingHours)
          })
        } else {
          resolve(openingHours)
        }
        resolve(openingHours)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getSlots ({ state }, { pageId, date, save }) {
    return new Promise((resolve, reject) => {
      if (save) {
        state.slots = null
      }
      pageService.getSlots(pageId, date).then((slots) => {
        if (save) {
          state.slots = slots
        }
        resolve(slots)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  storeSlots ({ state, dispatch }, { pageId, start, end, openingHours }) {
    let startDate = moment(start, 'YYYY-MM-DD')
    let endDate = moment(end, 'YYYY-MM-DD')
    const promises = []
    for (let day = startDate; day.isSameOrBefore(endDate); day.add(1, 'd')) {
      let get = true
      if (openingHours) {
        const dateMoment = moment(day).startOf('day').add(1, 'ms')
        const foundOpeningHours = getOpeningHoursForDate(dateMoment, openingHours)
        if (!foundOpeningHours) {
          get = false
        }
      }
      if (get) {
        const dayString = day.format('YYYY-MM-DD')
        promises.push(dispatch('getSlots', { pageId, date: dayString }).then((slots) => {
          state.storedSlots[dayString] = slots
        }))
      }
    }
    return Promise.all(promises).catch(() => {})
  },
}

const mutations = {
  setDashboardItems (state, items) {
    Vue.set(state, 'dashboardItems', items)
  },
  setPage (state, page) {
    Vue.set(state, 'page', page)
  },
  setUpcomingEvents (state, { startDate, endDate, upcomingEvents, activityCategoryIds }) {
    state.upcomingEvents = upcomingEvents
    state.upcomingEventsFilters.startDate = startDate
    state.upcomingEventsFilters.endDate = endDate
    state.upcomingEventsFilters.activityCategoryIds = activityCategoryIds
  },
  reset (state) {
    state.dashboardItems = []
    state.page = null
    state.openingHours = []
    state.slots = null
    state.storedSlots = {}
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
